import React, { Component, Fragment, useContext, } from "react";

// SB SHOW ON ESC
import useEventListener from "@use-it/event-listener";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Route,
  Switch,
  Link,
  useParams,
  withRouter,
} from "react-router-dom";
import styled, { css } from "styled-components";
import Bg from "../Bg";
import Cart from "./Cart";
import Menu from "./Menu";
import Navbar from "./Navbar";
import Popup from "../Popup";
import Preloader from "../Preloader.js";
import ProductList from "./ProductList";
import Tabbed from "../account/Tabbed";
import UserAccount, { Ex_UserAccountNoti } from '../account/UserAccount';
import { ProductConsumer, ProductContext } from "../../context";
import SiteBuilder from "../../sb/SiteBuilder";
import "./xsolla_shop.css";

const ESCAPE_KEYS = ["27", "Escape"];





const Store = ({history, match, location}) => {

  let { id } = useParams();

  const valueFromContext = useContext(ProductContext)


    return (
      <Fragment>
      <Navbar root="/store/" />
      {valueFromContext.psToken && <div className="">

        {valueFromContext["sections"].map((section, ind) => (
          <div key={`list_${ind}`}>

            <ProductList
              title={section["title"]}

              blockOrder={ind}
              filter={match.params.id === 'inventory' ? "is_favorite" : null}
              />
                    {/* <Bg
                      absolute={true}
                      image={false}
                      theme={
                        valueFromContext["sections"][ind]["theme"] ||
                        valueFromContext.theme
                      }
                    /> */}


          </div>
        ))}

          {['profile','orders','subscriptions','payment', 'notification', 'refunds'].includes(match.params.id) &&
            <UserAccount
              root='/store/'
            />
          }

          <Bg/>

              </div>
        }

        {valueFromContext.fetching && <Preloader />}

      </Fragment>
    )



}













const CssBody = styled.div`



  @media (max-width: 991px) {
    font-size: 14px;
  }

  @media (max-width: 767px) {
    font-size: 14px;
  }

  @media (max-width: 479px) {
    font-size: 13px;
  }
  /* font-family: ${({ theme }) =>
    theme["fontFamily"] ? theme["fontFamily"] : "Roboto"}; */
  font-family: "Roboto";
`;

export const Sb0 = ({ children }) => {
  const valueFromContext = React.useContext(ProductContext);
  const handlerEsc = ({ key }) => {
    if (ESCAPE_KEYS.includes(String(key))) {
      valueFromContext.setStateFrom("sbShown", !valueFromContext.sbShown);
    }
  };
  useEventListener("keydown", handlerEsc);

  return (
    <CssSb0
      shown={valueFromContext["sbShown"]}
      onClick={() => {
        if (!valueFromContext["sbShown"])
          valueFromContext["setStateFrom"]("sbShown", true);
      }}
    >
      {children}
    </CssSb0>
  );
};

const CssSb0 = styled.div`
  ${({ shown }) =>
    shown &&
    css`
      background-color: #506373;
      color: #506373;
      height: 100vh;
      display: flex;
      position: relative;
    `};
  ${({ shown }) =>
    !shown &&
    css`
      width: 24px;
      height: 24px;
      right: 0;
      background: white;
      overflow: hidden;
      /* border: 10px solid red; */
      &::after {
        content: "↓";
        position: absolute;
        color: black;
        text-align: center;
        width: 100%;
      }
    `};
  position: fixed;
  z-index: 3;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (max-width: 479px) {
  }
`;

const CssStore0 = styled.div`
  height: 100vh;
  z-index: 1;
  /* font-family: ${({ theme }) =>
    theme["fontFamily"] ? theme["fontFamily"] : "Roboto"}; */
  position: relative;
  padding-top: ${({ sbShown }) => (sbShown ? "64px" : "0px")};
  padding-left: ${({ sbShown }) => (sbShown ? "320px" : "0px")};

  @media (max-width: 991px) {

  }

  @media (max-width: 767px) {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }

  @media (max-width: 479px) {
    padding-left: 0 !important;
  }

`;

const CssCart = styled(Cart)`
  /* background-color: #506373; */
  left: 0;
  top: 0;
  height: 100vh;
  display: grid;
  align-items: center;
  position: relative;
  z-index: 100;
`;

export default withRouter(Store);
